<template>
  <section v-if="columns">
    <div
      v-for="columnKey in columnsKeys"
      :key="columnKey"
      class="column">
      <div class="card is-min-width-350 height-100 is-flex is-flex-direction-column">
        <header class="card-header pd-10px column is-narrow">
          <h5 class="has-text-weight-bold">
            {{ columns[columnKey].title }}
          </h5>
        </header>
        <dnd-container
          @drop="onDrop(columnKey, $event)"
          :get-child-payload="getChild(columnKey)"
          group-name="1"
          class="card-content is-paddingless has-background-background column overflow-auto">
          <dnd-draggable
            v-for="item in columns[columnKey].data"
            :key="item.id">
            <slot :item="item" />
          </dnd-draggable>
        </dnd-container>
      </div>
    </div>
  </section>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd';

export default {
  props: {
    columns: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      default: 'id',
    },
  },
  components: {
    DndContainer: Container,
    DndDraggable: Draggable,
  },
  computed: {
    columnsKeys() {
      return Object.keys(this.columns);
    },
  },
  methods: {
    getChild(columnKey) {
      return (index) => {
        return this.columns[columnKey].data[index];
      };
    },
    moveItem(from, fromIndex, to, toIndex, item) {
      return (newItem) => {
        this.columns[from].data.splice(fromIndex, 1);
        this.columns[to].data.splice(toIndex, 0, newItem ?? item);
        this.$emit('done');
      };
    },
    onDrop(columnKey, event) {
      if (event.addedIndex !== null) {
        let fromIndex = 0;
        const from = this.columnsKeys.find(key => {
          const find = this.columns[key].data.findIndex(i => {
            return i.id === event.payload.id;
          });
          if (find !== -1) {
            fromIndex = find;
            return true;
          }
          return false;
        });
        this.$emit('move', {
          from: from,
          to: columnKey,
          item: event.payload,
          approuved: this.moveItem(from, fromIndex, columnKey, event.addedIndex, event.payload),
        });
      }
    },
  },
};
</script>

<style>

</style>
